<template>
  <div>
    <h5>Werte des Auswahlfelds</h5>
    <v-list min-width="300" outlined>
      <v-list-item v-for="value in selectValues" :key="value">
        <v-list-item-content>
          <v-list-item-title>{{ value }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon @click="removeItem(value)">{{ mdiDelete }}</v-icon>
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-text-field v-model="textFieldVale" dense></v-text-field>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon :disabled="disableAddButton" @click="addItem">{{
            mdiPlus
          }}</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref } from "vue"
import { mdiDelete, mdiPlus } from "@mdi/js"

export default defineComponent({
  name: "CustomAttributesSelectValues",
  props: {
    values: {
      type: Array as PropType<string[]>,
      required: false,
    },
  },
  setup(props, { emit }) {
    const selectValues = ref(props.values ?? [])

    const emitSelectValues = () => {
      emit("change", selectValues.value)
    }

    const removeItem = (value: string) => {
      selectValues.value = selectValues.value.filter((v) => v !== value)
      emitSelectValues()
    }

    const addItem = () => {
      selectValues.value = [...selectValues.value, textFieldVale.value]
      textFieldVale.value = ""
      emitSelectValues()
    }

    const textFieldVale = ref("")
    const disableAddButton = computed(() => textFieldVale.value === "")

    return {
      selectValues,
      emitSelectValues,
      mdiDelete,
      mdiPlus,
      removeItem,
      addItem,
      textFieldVale,
      disableAddButton,
    }
  },
})
</script>
